"use strict"

import React, { useState, useEffect } from "react"
import { Button } from "react-bootstrap"

import { isLTPM, withApplicationConfig } from "../../../../components/shared_components_registration"
import ReportGenerationModal from "./index"
import { registration } from "./utils"

function ReportGenerationButton({
  availableRuns,
  plotList,
  siteMetrics = [],
  siteReactors = [],
  config = {}, // From withApplicationConfig - Currently only used for LTPM
  intl,
}) {
  const [reportGenerationModal, setReportGenerationModal] = useState(false)
  const [allowShiftReportGeneration, setAllowShiftReportGeneration] = useState(true)
  useEffect(() => {
    if (isLTPM && config?.user?.permissions) {
      // Handle use case on LTPM where certain user types shouldn't be able to download data
      setAllowShiftReportGeneration(config.user.permissions.includes("can_download_run_obs_data"))
    }
  }, [config])

  return (
    <>
      {reportGenerationModal && allowShiftReportGeneration && (
        <ReportGenerationModal
          show={reportGenerationModal}
          onHide={() => setReportGenerationModal(false)}
          availableRuns={availableRuns}
          plotList={plotList}
          siteMetrics={siteMetrics}
          siteReactors={siteReactors}
          intl={intl}
        />
      )}
      <Button
        variant={"outline-primary"}
        title={registration.widget_title(intl)}
        disabled={!allowShiftReportGeneration}
        onClick={(e) => {
          e.preventDefault()
          setReportGenerationModal(true)
        }}
      >
        <span className={"fa fa-book"} aria-hidden={"true"} />
      </Button>
    </>
  )
}

export default withApplicationConfig(ReportGenerationButton)
